import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { Loader2, CheckCircle, XCircle, Clock } from 'lucide-react';
import api from '../../services/api';
import Logo from '../../components/Logo';
import './AguardandoAprovacao.css';

const AguardandoAprovacao = () => {
  const { pedidoId } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Pendente');
  const [pedidoNumero, setPedidoNumero] = useState('');

  const { data: pedidoData, refetch } = useQuery(
    ['pedido', pedidoId],
    async () => {
      const response = await api.get(`/api/pedidos/${pedidoId}`);
      return response.data.data.pedido;
    },
    {
      refetchInterval: 3000, // Buscar a cada 3 segundos
      enabled: !!pedidoId,
      onSuccess: (data) => {
        setStatus(data.status);
        setPedidoNumero(data.numero);
      }
    }
  );

  useEffect(() => {
    if (pedidoData) {
      setStatus(pedidoData.status);
      setPedidoNumero(pedidoData.numero);
      
      // Se aprovado ou confirmado, redirecionar para acompanhamento
      if (pedidoData.status === 'Confirmado' || 
          pedidoData.status === 'Em preparo' || 
          pedidoData.status === 'Pronto' ||
          pedidoData.status === 'Saiu para entrega') {
        setTimeout(() => {
          navigate(`/acompanhar/${pedidoData.numero}`);
        }, 2000);
      }
      
      // Se cancelado, mostrar mensagem
      if (pedidoData.status === 'Cancelado') {
        // Não redirecionar, apenas mostrar mensagem
      }
    }
  }, [pedidoData, navigate]);

  return (
    <div className="aguardando-aprovacao">
      <div className="aguardando-content">
        <Logo size="large" />
        
        <div className="status-icon">
          {status === 'Pendente' && (
            <div className="spinner-container">
              <Loader2 className="spinning" size={64} />
            </div>
          )}
          {status === 'Confirmado' && (
            <CheckCircle size={64} className="success-icon" />
          )}
          {status === 'Cancelado' && (
            <XCircle size={64} className="error-icon" />
          )}
        </div>

        <h1>
          {status === 'Pendente' && 'Aguardando Aprovação'}
          {status === 'Confirmado' && 'Pedido Aprovado!'}
          {status === 'Cancelado' && 'Pedido Cancelado'}
        </h1>

        <p className="status-message">
          {status === 'Pendente' && 'Seu pedido está sendo analisado pelo estabelecimento...'}
          {status === 'Confirmado' && 'Seu pedido foi confirmado! Redirecionando...'}
          {status === 'Cancelado' && 'Infelizmente seu pedido foi cancelado. Entre em contato conosco para mais informações.'}
        </p>

        {pedidoNumero && (
          <div className="pedido-info">
            <p>Número do Pedido:</p>
            <strong>{pedidoNumero}</strong>
          </div>
        )}

        {status === 'Pendente' && (
          <div className="aguardando-tips">
            <Clock size={20} />
            <p>Aguarde alguns instantes...</p>
          </div>
        )}

        {status === 'Cancelado' && (
          <button 
            className="btn-voltar"
            onClick={() => navigate('/cardapio')}
          >
            Voltar ao Cardápio
          </button>
        )}
      </div>
    </div>
  );
};

export default AguardandoAprovacao;

